import { render, staticRenderFns } from "./drawer-form.vue?vue&type=template&id=56f80545&scoped=true"
import script from "./drawer-form.vue?vue&type=script&lang=js"
export * from "./drawer-form.vue?vue&type=script&lang=js"
import style0 from "./drawer-form.vue?vue&type=style&index=0&id=56f80545&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f80545",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56f80545')) {
      api.createRecord('56f80545', component.options)
    } else {
      api.reload('56f80545', component.options)
    }
    module.hot.accept("./drawer-form.vue?vue&type=template&id=56f80545&scoped=true", function () {
      api.rerender('56f80545', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-common/drawer-form.vue"
export default component.exports